import { render, staticRenderFns } from "../templates/normal_fcont_164.html?vue&type=template&id=6d152ab5&scoped=true&"
import script from "./normal_fcont_164.vue?vue&type=script&lang=js&"
export * from "./normal_fcont_164.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d152ab5",
  null
  
)

export default component.exports